module.exports = __webpack_public_path__ + "img/share.26cbb952.svg";